import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import _ from 'lodash';

import t from '../../lib/I18n';
import connectToStores from '../../helpers/connectToStores';
import ModalActions from '../../actions/ModalActions';
import { GlobalModals } from '../../constants/AppConstants';
import DimensionsStore from '../../stores/DimensionsStore';

import BaseModal from '../general/BaseModal';
import LoginForm from './Form';
import LoginModalHeader from './LoginModalHeader';
import LoginModalFooter from './LoginModalFooter';

const _getStateFromStores = () => ({
    isMobileWidth: DimensionsStore.isMobileWidth(),
});

class LoginModal extends React.PureComponent {
    static propTypes = {
        titleText: PropTypes.string,
        registerTitleText: PropTypes.string,
        onLogin: PropTypes.func,
        onCancel: PropTypes.func,
        onCancelRegister: PropTypes.func,
        onRegisterSuccessClose: PropTypes.func,
        moreInfoText: PropTypes.string,
        forceSmartcardSignup: PropTypes.bool,
        onCloseSmartcardError: PropTypes.func,
        hideSmartcardCheckbox: PropTypes.bool,
        hideSmartcardPromotionalText: PropTypes.bool,
        withISRN: PropTypes.bool,
        disableSuccessDropdown: PropTypes.bool,
        onSmartcardSuccess: PropTypes.func,
        emailDefaultValue: PropTypes.string,
        withoutNotifications: PropTypes.bool,
        isMobileWidth: PropTypes.bool,
        disableBlur: PropTypes.bool,
        disableEscape: PropTypes.bool,
        hideClose: PropTypes.bool,
        handleRegister: PropTypes.func,
        isBrochureRedirect: PropTypes.bool,
        initialPath: PropTypes.string,
    };

    static defaultProps = {
        titleText: 'account.login',
        registerTitleText: 'account.register',
        onLogin: _.noop,
        onCancel: _.noop,
        onCancelRegister: _.noop,
        onRegisterSuccessClose: _.noop,
        onCloseSmartcardError: _.noop,
        moreInfoText: null,
        forceSmartcardSignup: false,
        hideSmartcardCheckbox: false,
        hideSmartcardPromotionalText: false,
        withISRN: false,
        disableSuccessDropdown: false,
        onSmartcardSuccess: _.noop,
        emailDefaultValue: null,
        withoutNotifications: false,
        isMobileWidth: false,
        disableBlur: false,
        disableEscape: false,
        hideClose: false,
        handleRegister: null,
        isBrochureRedirect: false,
        initialPath: ''
    };

    state = {
        isLoginFormComplete: false
    };

    closeModal = ({ canRedirect = true } = {}) => {
        _.defer(() => {
            ModalActions.close(GlobalModals.LOGIN);
            this.props.onCancel({ canRedirect });
        });
    };

    _handleCancel = ({ canRedirect = false } = {}) => {
        this.closeModal({ canRedirect });
    };

    handleRegister = () => {
        this.props.onCancel({ canRedirect: false });
        ModalActions.open(GlobalModals.REGISTER, {
            onSuccessClose: this.props.onRegisterSuccessClose,
        });
    };

    onFormChange = form => {
        this.setState({ isLoginFormComplete: form.isComplete() });
    };

    renderModal = props => {
        const modalProps = {
            onClose: this._handleCancel,
            onContinue: props.onLogin,
            className: 'modal--login modal--xs',
            titleText: this.props.titleText,
            disableContinue: props.isLoggingIn,
            header: <LoginModalHeader
                closeModal={ this.closeModal }
                handleRegister={ this.props.handleRegister || this.handleRegister }
                onClose={ this._handleCancel }
                hideClose={ this.props.hideClose }
            />,
            footer: <LoginModalFooter
                handleLogin={ props.onLogin }
                handleRegister={ this.props.handleRegister || this.handleRegister }
                nextButtonActive
            />,
            headerClass: 'modal__header',
            isAutofocusing: true,
            useFlex: true,
            bodyAriaLabel: t(`login.modal.body.ariaLabel`),
            disableBlur: this.props.disableBlur,
            disableEscape: this.props.disableEscape,
        };

        return (
            <BaseModal { ...modalProps }>
                <form>
                    <div className="login">
                        <section className="login__standard login__standard--no-providers">
                            <Row>
                                <Col xs={ 12 }>
                                    <h1 className="login__heading">
                                        { this.props.isMobileWidth ? t('login.subtitle') : t('account.login') }
                                    </h1>
                                    {this.props.moreInfoText && (
                                        <p className="login__more-info">
                                            {t(`${this.props.moreInfoText}`)}
                                        </p>
                                    )}
                                    {props.loginComponent}
                                </Col>
                            </Row>
                        </section>
                    </div>
                </form>
            </BaseModal>
        );
    };

    render() {
        const {
            registerTitleText,
            titleText,
            onLogin,
            onCancel,
            onCancelRegister,
            onRegisterSuccessClose,
            forceSmartcardSignup,
            onCloseSmartcardError,
            hideSmartcardCheckbox,
            hideSmartcardPromotionalText,
            withISRN,
            disableSuccessDropdown,
            onSmartcardSuccess,
            emailDefaultValue,
            withoutNotifications,
            isBrochureRedirect,
            isMobileWidth,
            initialPath
        } = this.props;

        const handleLogin = () => {
            ModalActions.close(GlobalModals.LOGIN);
            onLogin();
        };

        return (
            <LoginForm
                onLogin={ handleLogin }
                registerTitleText={ registerTitleText }
                titleText={ titleText }
                onCancel={ onCancel }
                onCancelRegister={ onCancelRegister }
                onRegisterSuccessClose={ onRegisterSuccessClose }
                onFormChange={ this.onFormChange }
                forceSmartcardSignup={ forceSmartcardSignup }
                disableSuccessDropdown={ disableSuccessDropdown }
                onSmartcardSuccess={ onSmartcardSuccess }
                emailDefaultValue={ emailDefaultValue }
                hideSmartcardCheckbox={ hideSmartcardCheckbox }
                hideSmartcardPromotionalText={ hideSmartcardPromotionalText }
                onCloseSmartcardError={ onCloseSmartcardError }
                withISRN={ withISRN }
                withoutNotifications={ withoutNotifications }
                isBrochureRedirect={ isBrochureRedirect }
                isMobileWidth={ isMobileWidth }
                initialPath={ initialPath }
            >
                {this.renderModal}
            </LoginForm>
        );
    }
}

export default connectToStores([DimensionsStore], _getStateFromStores)(LoginModal);
